import * as yaml from 'js-yaml';
import { S3File } from 'features/file-browser/state/fileAtoms';
import { isValidStudyName, STUDY_NAME_ERROR } from 'shared/validation/studyName';

const TireFileList = ["Tire_FR.stl", "Tire_FL.stl", "Tire_RR.stl", "Tire_RL.stl"];
const WheelhouseFileList = ["Wheelhouse_FR.stl", "Wheelhouse_FL.stl", "Wheelhouse_RR.stl", "Wheelhouse_RL.stl"];

export const isSendable = (
  yamlConfig: string,
  allTires: S3File[],
  allWheelhouses: S3File[]
) => {
  try {
    const config: any = yaml.load(yamlConfig);
    if (config?.application.study_name === '') {
      alert('study nameを入力して下さい。');
      return false;
    } else if (!isValidStudyName(config?.application.study_name)) {
      alert(STUDY_NAME_ERROR);
      return false;
    } else if (config?.application.base_stl === '') {
      alert('モーフィングする車体モデルを選択し、描画して下さい。');
      return false;
    } else if (config?.application.morphing_parameters.length === 0) {
      alert('モーフィングパラメータが設定されていません。');
      return false;
    } else if (config?.cfd.car_type === 'car_rotating_tire_exposed') {
      const tireNames = allTires.map(tire => tire.name).sort();
      const isTireMatch = tireNames.length === TireFileList.length &&
        tireNames.every((name, index) => name === TireFileList.sort()[index]);

      if (!isTireMatch) {
        alert('タイヤモデルが4つ揃っていない、或いは名前が異なっています。');
        return false;
      } else {
        return true;
      }
    } else if (config?.cfd.car_type === 'car_rotating_tire') {
      const tireNames = allTires.map(tire => tire.name).sort();
      const isTireMatch = tireNames.length === TireFileList.length &&
        tireNames.every((name, index) => name === TireFileList.sort()[index]);

      const wheelhouseNames = allWheelhouses.map(wheelhouse => wheelhouse.name).sort();
      const isWheelhouseMatch = wheelhouseNames.length === WheelhouseFileList.length &&
        wheelhouseNames.every((name, index) => name === WheelhouseFileList.sort()[index]);

      if (!isTireMatch) {
        alert('タイヤモデルが4つ揃っていない、或いは名前が異なっています。');
        return false;
      } else if (!isWheelhouseMatch) {
        alert('ホイールハウスモデルが4つ揃っていない、或いは名前が異なっています。');
        return false;
      } else {
        return true;
      }
    } else {
      const max = config.application.design_space.max;
      const min = config.application.design_space.min;
      const volume = (max[0] - min[0]) * (max[1] - min[1]) * (max[2] - min[2]);
      if (volume === 0) {
        alert('デザインスペースの体積が0です。');
        return false;
      }
      return true;
    }
  } catch (error) {
    alert('YAMLのパースに失敗しました。' + error);
    return false;
  }
};
